"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var isFieldRequired = function isFieldRequired(validators) {
  return (0, _lodash.some)(validators, {
    validation_type: 'presence'
  });
};
var _default = exports["default"] = isFieldRequired;